export default __webpack_public_path__ + "static/media/https.78d445ad.svg";